import {
  Component,
  contentChild,
  contentChildren,
  effect,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';


@Component({
  selector: 'soft-page-header',
  imports: [],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css',
})
export class PageHeaderComponent {
  template = viewChild(TemplateRef);
  customClass = input('soft-page-header');
  constructor() {}
}
